export default function getPositionData(array, index) {
  const positionData = {};

  const prevVideo = array[index - 1];
  const nextVideo = array[index + 1];

  if (prevVideo) {
    positionData.afterId = prevVideo;
  }
  if (nextVideo) {
    positionData.beforeId = nextVideo;
  }

  return positionData;
}



// WEBPACK FOOTER //
// ./src/shared/redux/helpers/position-data.js